import ModelService from '../base/ModelService';

class Pixabay extends ModelService {
  constructor() {
    super('pixabay');
  }
}

export default new Pixabay();
